import {Solicitud} from "../../entities/solicitudes/Solicitud";

export const SET_SOLICITUD = 'SET_SOLICITUD';
export const SET_SOLICITUD_COPIA = 'SET_SOLICITUD_COPIA';

interface ISetSolicitud {
    type: typeof SET_SOLICITUD
    solicitud: Solicitud
}

interface ISetSolicitudCopia {
    type: typeof SET_SOLICITUD_COPIA
    solicitud: Solicitud
}

export type SolicitudActionTypes = ISetSolicitud | ISetSolicitudCopia
